import { render, staticRenderFns } from "./MakeClips.vue?vue&type=template&id=1f12d0f4&scoped=true"
import script from "./MakeClips.vue?vue&type=script&lang=js"
export * from "./MakeClips.vue?vue&type=script&lang=js"
import style0 from "./MakeClips.vue?vue&type=style&index=0&id=1f12d0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f12d0f4",
  null
  
)

export default component.exports